import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    scannedPackages: [],
    generatedStops: [],
    optimizedRoute: null,
    currentStep: 1,
    deliveryId: null,
};

const routeFlowSlice = createSlice({
    name: "routeFlow",
    initialState,
    reducers: {
        // Step 1: Scan Packages
        addScannedPackage: (state, action) => {
            const exists = state.scannedPackages.find((pkg) => pkg.Waybill === action.payload.Waybill);
            if (!exists) {
                state.scannedPackages.push(action.payload);
            }
        },
        removeScannedPackage: (state, action) => {
            state.scannedPackages = state.scannedPackages.filter((pkg) => pkg.Waybill !== action.payload);
        },
        clearScannedPackages: (state) => {
            state.scannedPackages = [];
        },

        // Step 2: Generated Stops
        setGeneratedStops: (state, action) => {
            state.generatedStops = action.payload;
        },
        updateStop: (state, action) => {
            const index = state.generatedStops.findIndex((stop) => stop.stopId === action.payload.stopId);
            if (index !== -1) {
                state.generatedStops[index] = {
                    ...state.generatedStops[index],
                    ...action.payload,
                };
            }
        },
        removeStop: (state, action) => {
            state.generatedStops = state.generatedStops.filter((stop) => stop.stopId !== action.payload);
        },

        // Step 4: Optimized Route
        setOptimizedRoute: (state, action) => {
            state.optimizedRoute = action.payload;
        },

        // Navigation
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        nextStep: (state) => {
            if (state.currentStep < 4) {
                state.currentStep += 1;
            }
        },
        previousStep: (state) => {
            if (state.currentStep > 1) {
                state.currentStep -= 1;
            }
        },

        // Delivery
        setDeliveryId: (state, action) => {
            state.deliveryId = action.payload;
        },

        // Reset
        resetRouteFlow: () => initialState,
    },
});

export const { addScannedPackage, removeScannedPackage, clearScannedPackages, setGeneratedStops, updateStop, removeStop, setOptimizedRoute, setCurrentStep, nextStep, previousStep, setDeliveryId, resetRouteFlow } = routeFlowSlice.actions;

export default routeFlowSlice.reducer;
